/* ============================================================================
   SACRASOUL BROWSE (Lane C) — deferred, component-scoped behaviours.
   Ported from tasks/collections-vision/collections-page.html (Variant A).
   Buy-control state machine · intent filter · reveal · scroll-spy rail · kit
   dots · the branching ritual quiz. Adds go through the shared SacrasoulCart
   (real /cart/add forms are intercepted globally; the quiz uses addAndOpen).
   ========================================================================== */
(function () {
  /* Tells the inline motion gate in sections/sacrasoul-browse.liquid that the
     animator arrived, so its 2s watchdog stands down and the reveal animations
     keep their designed behaviour. */
  window.__ssbBooted = true;
  'use strict';
  /* =========================== LOCALE STRINGS ===========================
     This file is one static asset shared by every market, so nothing it writes
     into the page can be a literal. sacrasoul-browse.liquid renders #ssb-i18n
     from the locale files; the literals below are the degrade path if it is
     ever absent, never what a non-English shopper sees. */
  var I18N = {};
  try { I18N = JSON.parse(document.getElementById('ssb-i18n').textContent) || {}; } catch (e) { I18N = {}; }
  function tr(path, fallback) {
    var v = I18N, parts = path.split('.');
    for (var i = 0; i < parts.length; i++) { if (v == null) return fallback; v = v[parts[i]]; }
    return v == null || v === '' ? fallback : v;
  }

  var root = document.querySelector('.ssb-root');
  if (!root) return;

  /* ---------- tiny toast (notify stub + quiz "sent"; real adds use the shared drawer's own toast) ---------- */
  var toastEl;
  function toast(html) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'ssb-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.style.cssText = 'position:fixed;left:50%;bottom:80px;transform:translate(-50%,20px);z-index:9999;background:#1C1B1A;color:#FDFBF9;padding:12px 20px;border-radius:4px;font-size:14px;font-family:var(--fonts-body,sans-serif);opacity:0;visibility:hidden;transition:opacity .3s,transform .3s;box-shadow:0 10px 34px rgba(28,27,26,.3)';
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = html;
    toastEl.style.opacity = '1'; toastEl.style.visibility = 'visible'; toastEl.style.transform = 'translate(-50%,0)';
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toastEl.style.opacity = '0'; toastEl.style.visibility = 'hidden'; toastEl.style.transform = 'translate(-50%,20px)'; }, 2200);
  }

  /* ================= SOLD-OUT MEMORY (one visit, provisional) =================
     snippets/browse-buy.liquid gates every size chip and the Add on v.available
     AT RENDER, and Shopify serves collection HTML from the edge cache — so that
     flag is true as of whenever the section was cached, not as of this tap. When
     it has gone stale the shopper taps a live control and Shopify answers 422
     "already sold out". The verdict below retires the control; the problem is
     that the verdict lived in this document only, and the document is exactly
     what a reload or a back navigation throws away. The same cached markup came
     back with the same live control, and load two spent a second 422 to
     rediscover load one's answer.

     So it is written down. sessionStorage, not localStorage: the bound is a
     visit, because stock comes back and a control remembered for weeks would
     hide a restock. Per tab, which is what sessionStorage means — a second tab
     starts empty and pays its own first 422.

     And it is PROVISIONAL, never a verdict of its own. Everything remembered is
     re-checked against /products/<handle>.js, which is product JSON rather than
     cached section HTML, and any variant that comes back available is dropped
     from the memory and its control handed back. A sellout the shop has since
     reversed must not go on suppressing a sale for the rest of the visit. */
  var DEAD_KEY = 'ss_soldout_variants';
  var DEAD_MAX = 50;             /* far past what one visit can watch sell out */
  /* Refusals are ORDERED against in-flight revalidations. A product request
     leaves before a sellout and lands after it; looping its "available" answer
     against current storage would erase the newer verdict and re-arm a control
     the shop just refused (repeat 422s, the exact waste this memory ends).
     deadWhen[id] stamps each refusal with a generation; revalidate() captures
     the generation it left with and may only clear verdicts at or before it.
     In-memory on purpose: a response can only race events in its own document. */
  var deadGen = 0;
  var deadWhen = {};
  /* The in-document copy of the memory. sessionStorage can refuse the write
     (private mode, quota); this list cannot, so retirement in the page the
     shopper is standing on never depends on storage accepting it. readDead()
     serves the union. */
  var memDead = [];
  function readDead() {
    var stored = [];
    try {
      var raw = JSON.parse(sessionStorage.getItem(DEAD_KEY) || '[]');
      if (Array.isArray(raw)) stored = raw.map(String);
    } catch (e) { /* private mode, storage off, or a junk value */ }
    memDead.forEach(function (id) { if (stored.indexOf(id) < 0) stored.push(id); });
    return stored;
  }
  function writeDead(list) {
    try { sessionStorage.setItem(DEAD_KEY, JSON.stringify(list.slice(-DEAD_MAX))); }
    catch (e) { /* storage refused — memDead keeps this document honest */ }
  }
  function rememberDead(id) {
    if (!id) return;
    id = String(id);
    deadWhen[id] = ++deadGen;
    if (memDead.indexOf(id) < 0) memDead.push(id);
    var list = readDead().filter(function (x) { return x !== id; });
    list.push(id);
    writeDead(list);
  }
  function forgetDead(id) {
    id = String(id);
    memDead = memDead.filter(function (x) { return x !== id; });
    writeDead(readDead().filter(function (x) { return x !== id; }));
  }

  /* ================= CAP MEMORY (this document only) =================
     A cap is the other stock refusal: the size still sells, the shopper simply
     holds every remaining unit already. Until the drawer learned to tell the
     two apart on a MULTI-VARIANT product (addInventoryVerdict), a sized card
     could only ever be told 'sold_out', so this ending was unreachable here and
     its old handling — hard-disable, busy flag never released — was never paid
     for. It cannot stand now: syncAdd refuses a busy button, so the stuck flag
     would leave the SIZE BESIDE the capped one unbuyable without a navigation,
     which is the exact fault the sold-out path was fixed for.

     So a cap rides the same syncAdd/applyDead pipeline as the dead memory, with
     one difference: it is never written down. A cap is undone by the shopper
     themselves — remove a unit in the drawer this very add just opened — and a
     verdict that outlived the tap would kill a card that still sells. Memory
     only, this document, gone on the next load. */
  var memCapped = [];
  function rememberCapped(id) {
    if (!id) return;
    id = String(id);
    if (memCapped.indexOf(id) < 0) memCapped.push(id);
  }
  function forgetCapped(id) {
    id = String(id);
    if (memCapped.indexOf(id) < 0) return false;
    memCapped = memCapped.filter(function (x) { return x !== id; });
    return true;
  }

  /* A chip Liquid rendered sold-out carries no data-variant-id, so it is never
     seen here; _ssDead marks the ones this file turned off, and only those are
     ever turned back on. The same rule guards the Add through _ssDeadOff: a
     button the server rendered disabled must stay that way. */
  function paintChip(seg, dead) {
    var pz = seg.querySelector('.ssb-pz');
    if (dead) {
      if (seg._ssDead) return;
      seg._ssDead = true;
      if (pz) { seg._ssPz = pz.textContent; pz.textContent = tr('soldOut', 'Sold out'); }
      seg.disabled = true;
      seg.setAttribute('aria-disabled', 'true');
      seg.setAttribute('aria-pressed', 'false');
    } else if (seg._ssDead) {
      seg._ssDead = false;
      if (pz && seg._ssPz != null) pz.textContent = seg._ssPz;
      seg.disabled = false;
      seg.removeAttribute('aria-disabled');
    }
  }
  function syncAdd(buy, dead) {
    var input = buy.querySelector('[data-buy-id]');
    var btn = buy.querySelector('.ssb-add');
    if (!input || !btn || btn.dataset.busy) return false;   /* never rewrite a button mid-add */
    var lead = btn.querySelector('.ssb-add-lead');
    var id = input.value && String(input.value);
    /* A sellout outranks a cap: if the shop has since refused this size
       outright, "All in cart" would invite a shopper to go free a unit that
       would not buy it back. */
    var isDead = !!id && dead.indexOf(id) >= 0;
    var capped = !isDead && !!id && memCapped.indexOf(id) >= 0;
    var off = isDead || capped;
    if (off) {
      var word = capped ? tr('addMaxed', 'All in cart') : tr('soldOut', 'Sold out');
      /* Already retired: the button is staying off, and the only thing left that
         can change is the WORD — a card reading "All in cart" whose size the
         shop has since refused outright. Returning here before recomputing it
         left the precedence above written but not delivered. _ssLead is never
         re-captured on this branch: it holds the PRE-TAP label, and what the
         lead carries now is the retirement text. */
      if (btn._ssDeadOff) {
        if (lead && btn._ssWord !== word) { lead.textContent = word; btn._ssWord = word; }
        return true;
      }
      btn._ssDeadOff = true;
      if (lead) { btn._ssLead = lead.innerHTML; lead.textContent = word; btn._ssWord = word; }
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
    } else if (btn._ssDeadOff) {
      btn._ssDeadOff = false;
      btn._ssWord = null;
      if (lead && btn._ssLead != null) lead.innerHTML = btn._ssLead;
      /* The retirement text destroyed [data-price-node], so the restored HTML
         carries the price frozen at retire time — the REFUSED size's price.
         Re-price from the size the shopper has selected now (chooseSeg sets
         aria-pressed before calling here). */
      var chosen = buy.querySelector('[data-seg][aria-pressed="true"]');
      var priceNode = buy.querySelector('[data-price-node]');
      if (chosen && priceNode && chosen.dataset.price) priceNode.textContent = chosen.dataset.price;
      btn.disabled = false;
      btn.removeAttribute('aria-disabled');
    }
    return off;
  }
  /* Idempotent in both directions: it retires what the memory names and revives
     what it no longer names, so one function serves boot, a fresh refusal and
     the answer from the availability re-check. Returns the cards it touched. */
  function applyDead() {
    var dead = readDead(), touched = [];
    root.querySelectorAll('.ssb-buy').forEach(function (buy) {
      var hit = false;
      buy.querySelectorAll('[data-seg][data-variant-id]').forEach(function (seg) {
        var d = dead.indexOf(String(seg.dataset.variantId)) >= 0;
        if (d) hit = true;
        paintChip(seg, d);
      });
      if (syncAdd(buy, dead)) hit = true;
      if (hit) touched.push(buy);
    });
    /* The STANDALONE forms — kit cards, and the attar bottle/sample pair — carry
       no .ssb-buy ancestor, so the sweep above never saw them. rememberDead()
       has always written their sellout down; nothing ever read it back, so the
       verdict died with the document and the next load re-armed a control the
       shop had already refused, spending a second 422 on it. The form is its
       own container: it holds the [data-buy-id] and the .ssb-add, which is all
       syncAdd needs. */
    root.querySelectorAll('form.ssb-buy-form').forEach(function (form) {
      if (form.closest('.ssb-buy')) return;
      if (syncAdd(form, dead)) touched.push(form);
    });
    return touched;
  }
  /* The refresh the memory is only honest with. One request per PRODUCT, and
     only for products carrying a remembered id on this page. */
  function revalidate(buys) {
    if (typeof fetch !== 'function') return;
    var seen = {};
    var startGen = deadGen;   /* verdicts after this moment outrank this fetch */
    buys.forEach(function (buy) {
      /* A standalone form is its own container (see applyDead), so it IS the
         form — without this it would never be re-checked, and a restocked kit
         would stay retired for the rest of the visit. */
      var form = buy.matches('form.ssb-buy-form') ? buy : buy.querySelector('form.ssb-buy-form');
      var url = form && form.dataset.productUrl;
      if (!url || seen[url]) return;
      seen[url] = true;
      fetch(url.split('?')[0] + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (!data || !data.variants) return;
          var revived = false;
          data.variants.forEach(function (v) {
            if (!v || !v.available) return;
            var id = String(v.id);
            if (readDead().indexOf(id) < 0) return;
            /* A refusal stamped after this request left is NEWER evidence than
               this response — a shopper tapped a sibling mid-flight and the
               shop said no. The older "available" must not erase it. */
            if ((deadWhen[id] || 0) > startGen) return;
            forgetDead(id);
            revived = true;
          });
          if (revived) applyDead();
        })
        .catch(function () { /* offline or a 404 — the memory simply stands */ });
    });
  }
  /* Before the first tap, not after it: everything this visit already watched
     the shop refuse is retired at boot, so a cached render cannot spend another
     422 rediscovering it — and re-checked against product JSON straight after,
     so a restock takes the control back without waiting for the tab to close.
     (It sits ABOVE the buy handlers deliberately: tests/browser/addbtn-proof.mjs
     runs the submit block standalone by slicing this file between those two
     markers, and a boot call caught in that slice throws in its fixture.) */
  (function () {
    function sweep() {
      var touched = applyDead();
      if (touched.length) revalidate(touched);
    }
    sweep();
    /* A back navigation can restore this page from bfcache exactly as it stood
       BEFORE the sellout — live controls, and no second run of this script.
       pageshow with persisted is the only notice that arrives. */
    window.addEventListener('pageshow', function (e) { if (e && e.persisted) sweep(); });
  })();

  /* The cap memory's way back. Without it that memory is write-only: the one
     thing that undoes a cap is the shopper freeing a unit, they do it in the
     drawer THIS add just opened, and they never leave the document — so a card
     reading "All in cart" stayed dead over stock the shop would now sell, until
     a full navigation. bfcache makes that worse, not better: pageshow restores
     this module with memCapped intact, so even a back-navigation did not clear
     it. cart_unit_freed is the drawer's signal that a held unit was released
     (assets/sacrasoul-cart-drawer.js), and it fires on the shopper's action
     rather than the server's answer, which is the safe direction to be wrong in:
     re-arming a card that is still capped costs one refused add, which writes
     the cap straight back, while missing the signal costs the sale.

     A SELLOUT is deliberately not undone here. It has its own evidence —
     revalidate() against product JSON — and freeing a unit says nothing about
     whether the shop has any left. */
  document.addEventListener('sacrasoul:behavior', function (ev) {
    var d = ev && ev.detail;
    if (!d || d.name !== 'cart_unit_freed') return;
    var id = d.properties && d.properties.variant_id;
    if (!id || !forgetCapped(id)) return;
    applyDead();
  });

  /* ================= BUY CONTROL — rest → open → ready ================= */
  function resetBuy(b) {
    if (!b) return;
    b.dataset.state = 'rest';
    var card = b.closest('.ssb-card');
    var headline = card && card.querySelector('.ssb-card-price');
    if (headline && headline.dataset.unselectedPrice !== undefined) headline.innerHTML = headline.dataset.unselectedPrice;
    b.querySelectorAll('[data-seg]').forEach(function (s) { s.setAttribute('aria-pressed', 'false'); });
    var o = b.querySelector('[data-open]'); if (o) o.setAttribute('aria-expanded', 'false');
  }
  /* The sizes open downward, inside the card. On a phone the card that was
     tapped is often the one sitting at the foot of the viewport, so the row of
     sizes and prices lands below the fold: the tap worked and the shopper saw
     nothing (replay 6 Sep, Facebook iOS: two of three prices clipped). The
     focus above keeps preventScroll so the page never jumps for a row that is
     already visible; this scrolls only when the row is actually cut off, and
     only by the smallest amount that shows it. Measured after the state
     change has painted, because the row is max-height:0 until then. */
  function revealSeg(buy) {
    var seg = buy.querySelector('.ssb-seg'); if (!seg) return;
    var check = function () {
      if (buy.dataset.state !== 'open' && buy.dataset.state !== 'ready') return;
      var r = seg.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      /* The row now takes its height in one frame, but scrollHeight stays the
         guard in case its box still reads flat on the first frame; it already
         knows the settled height. Not scrollIntoView: that reads the flat box, calls it visible
         and does nothing. Scroll the document by exactly the clipped amount. */
      var bottom = r.top + Math.max(r.height, seg.scrollHeight || 64);
      var delta = bottom - vh + 12;
      if (delta <= 0 || r.top < 0) return;
      if (window.scrollBy) window.scrollBy({ top: delta, behavior: 'smooth' });
    };
    requestAnimationFrame(check);
  }
  function chooseSeg(buy, seg) {
    buy.querySelectorAll('[data-seg]').forEach(function (s) { s.setAttribute('aria-pressed', 'false'); });
    seg.setAttribute('aria-pressed', 'true');
    buy.dataset.state = 'ready';
    var card = buy.closest('.ssb-card');
    var headline = card && card.querySelector('.ssb-card-price');
    if (headline && seg.dataset.price) {
      if (headline.dataset.unselectedPrice === undefined) headline.dataset.unselectedPrice = headline.innerHTML;
      headline.textContent = seg.dataset.price;
    }
    var input = buy.querySelector('[data-buy-id]'); if (input && seg.dataset.variantId) input.value = seg.dataset.variantId;
    var priceNode = buy.querySelector('[data-price-node]'); if (priceNode && seg.dataset.price) priceNode.textContent = seg.dataset.price;
    /* keep the drawer's optimistic paint truthful: the form's preview data
       follows the chosen size (title stays, price + variant label move). */
    var form = buy.querySelector('form.ssb-buy-form');
    if (form) {
      if (seg.dataset.priceCents) form.dataset.productPrice = seg.dataset.priceCents;
      if (seg.dataset.label) form.dataset.variantTitle = seg.dataset.label;
    }
    /* The Add follows the id now in the form. A card whose LEAD size is the
       remembered one arrives with the Add off; picking a size nobody refused
       has to hand it back, or the memory would cost the sale it exists to
       protect. And picking a remembered size cannot leave a live Add behind. */
    syncAdd(buy, readDead());
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('.ssb-card-link')) return; // let the PDP link through

    var opener = e.target.closest('[data-open]');
    if (opener) {
      var b = opener.closest('.ssb-buy');
      if (b) {
        var pre = opener.dataset.preselect;
        if (pre) {
          var target = b.querySelector('[data-seg][data-variant-id="' + pre + '"]');
          if (target) chooseSeg(b, target); else b.dataset.state = 'open';
        } else { b.dataset.state = 'open'; }
        opener.setAttribute('aria-expanded', 'true');
        var choice = b.querySelector('[data-seg][aria-pressed="true"]') || b.querySelector('[data-seg]:not([disabled])');
        if (choice) choice.focus({ preventScroll: true });
        revealSeg(b);
      }
      return;
    }
    var back = e.target.closest('[data-back]');
    if (back) {
      var owner = back.closest('.ssb-buy'); resetBuy(owner);
      var open = owner && owner.querySelector('[data-open]');
      if (open) open.focus({ preventScroll: true });
      return;
    }

    var seg = e.target.closest('[data-seg]');
    if (seg) {
      var buy = seg.closest('.ssb-buy'); if (!buy) return;
      // A second tap confirms the same choice. Back is the explicit reset.
      if (seg.disabled || seg.getAttribute('aria-disabled') === 'true') return;
      chooseSeg(buy, seg);
      return;
    }
    var notify = e.target.closest('[data-notify]');
    if (notify) {
      /* This was the one string in the file not routed through #ssb-i18n,
         against this file's own rule that nothing it writes can be a literal —
         a Polish shopper tapped "Powiadom mnie" and got an English sentence.
         It also promised an email: there is no capture backend behind it, so
         the demand was silently discarded. Send them to the product page, where
         the real back-in-stock control lives, instead of making a promise the
         store cannot keep. */
      var href = notify.getAttribute('data-notify-url') || (notify.closest('.ssb-card') || {}).querySelector
        && notify.closest('.ssb-card').querySelector('.ssb-card-link');
      var url = notify.getAttribute('data-notify-url')
        || (href && href.getAttribute && href.getAttribute('href'));
      if (url) { window.location.href = url; return; }
      toast(tr('notifyFallback', 'Open the product page to be notified.'));
      return;
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    root.querySelectorAll('.ssb-buy[data-state="open"],.ssb-buy[data-state="ready"]').forEach(resetBuy);
  });
  /* brief "Adding…" feedback on real form submit (the shared drawer handles the actual add) */
  root.addEventListener('submit', function (e) {
    var form = e.target.closest('.ssb-buy-form'); if (!form) return;
    var btn = form.querySelector('.ssb-add'); if (!btn) return;
    /* Busy guard cancels the SUBMIT, not just the label. It used to return
       early and let the event through, so a double tap added two units while
       the shopper saw one "Added". */
    if (btn.dataset.busy) { e.preventDefault(); e.stopPropagation(); return; }
    var lead = btn.querySelector('.ssb-add-lead'); if (!lead) return;
    var orig = lead.innerHTML; btn.dataset.busy = '1';
    lead.textContent = tr('adding', 'Adding…');

    /* Confirm from the cart engine, not from a timer. The old code painted
       "Added" after 420ms no matter what happened: on a 422, a dropped
       connection or an offline phone the button claimed success, the drawer
       never opened, nothing was in the cart, and no error event fired — so the
       failure was invisible in analytics too. */
    /* Match on the VARIANT, not just the event name. cart_item_added is emitted
       for any add anywhere — another card's, or an upsell added inside the very
       drawer this tap opened. Name-only matching meant a card whose own add had
       just 422'd could still read "Added" because the shopper then took the
       upsell. The variant is read at submit time because chooseSeg() rewrites
       the form's id when a size is picked. */
    var wantId = Number((form.querySelector('[name="id"]') || {}).value) || null;
    var settled = false;
    function finish(outcome) {
      if (settled) return; settled = true;
      document.removeEventListener('sacrasoul:behavior', onBehavior);
      /* An add the shop refused on stock is not a failed request, and "Try
         again" is an invitation to repeat a POST the engine has already cached
         as impossible — one shopper's repeat taps are the whole signal this
         change came from. The control retires instead: the label says what
         happened and the busy flag is never released. */
      if (outcome === 'sold_out' || outcome === 'cap') {
        /* THE MEMORY owns the retirement, for both verdicts: restore the
           pre-tap label, release the busy flag, and let applyDead() carry the
           verdict to this Add, the SIZE CHIP (sellouts only), and every other
           card pointing at the same variant. A stuck busy flag here was the bug
           — syncAdd() refuses busy buttons, so picking the size BESIDE the
           refused one could never hand the Add back and the surviving size was
           unbuyable without a navigation. */
        if (wantId) {
          /* Only a sellout is written down; a cap is remembered in this
             document only (see the CAP MEMORY note). Both then take the SAME
             route out, because both name one size and leave the others selling. */
          if (outcome === 'sold_out') rememberDead(wantId); else rememberCapped(wantId);
          /* Only when this form lives inside a .ssb-buy can syncAdd retire
             and later revive it. The standalone forms (kit cards, the attar
             bottle/sample pair) sit outside that structure — releasing THEIR
             busy flag would re-arm a control the memory cannot reach, so
             they keep the hard retire below — the same ending, reached one step
             sooner. applyDead() now sweeps them too, so the verdict survives
             the reload; it simply does not need to be replayed into this
             document, where the button is already dead. */
          if (form.closest('.ssb-buy')) {
            lead.innerHTML = orig;
            delete btn.dataset.busy;
            applyDead();
            return;
          }
        }
        lead.textContent = outcome === 'cap'
          ? tr('addMaxed', 'All in cart')
          : tr('soldOut', 'Sold out');
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
        return;
      }
      lead.textContent = outcome === 'added'
        ? tr('added', 'Added · View cart')
        : outcome === 'uncertain'
          ? tr('addUncertain', 'Check cart')
          : tr('addFailed', 'Try again');
      /* "Try again" answers in a second; the button goes back to being a
         button. "Check cart" is a request, and the busy flag is what stops
         the tap that would post a second time — so it holds long enough to
         be read, and to be acted on in the drawer already open over this
         card. "Added · View cart" holds 2s to match the re-tap-to-open
         window ss-quick-add-feedback.js marks on this same button (the
         quiet add's drawer confirmation) — the label and the tap behaviour
         retire together. Same timer family, three honest exceptions. */
      setTimeout(function () { lead.innerHTML = orig; delete btn.dataset.busy; },
        outcome === 'uncertain' ? 9000 : outcome === 'added' ? 2000 : 1050);
    }
    /* Failure has its own event now. Without it the only exit from a failed add
       was the 11s timer below, so the button read "Adding…" and swallowed every
       retry tap for eleven seconds after the engine had already given up at ten.
       It goes through the SAME variant guard as the success event: an unmatched
       failure belongs to another card. No-op if the engine never emits it. */
    function onBehavior(ev) {
      var d = ev && ev.detail;
      /* cart_add_unavailable is the engine's stock rejection, split out of
         cart_add_failed so the sold-out rate stops spending the fault counters.
         It has to be listened for here too, or a quick-add the shop refuses on
         stock settles on nothing and the card reads "Adding…" until the 29s
         backstop. Its reason carries the drawer's own verdict — sold_out, or
         cap when every remaining unit is already in the cart — and the two
         endings are different sentences. */
      if (!d || !['cart_item_added', 'cart_add_failed', 'cart_add_unavailable', 'cart_add_uncertain'].includes(d.name)) return;
      var got = d.properties && Number(d.properties.variant_id);
      if (wantId && got && got !== wantId) return;
      finish(d.name === 'cart_item_added' ? 'added'
        : d.name === 'cart_add_uncertain' ? 'uncertain'
        : d.name === 'cart_add_unavailable'
          ? (d.properties && d.properties.reason === 'cap' ? 'cap' : 'sold_out')
          : 'failed');
    }
    document.addEventListener('sacrasoul:behavior', onBehavior);
    /* backstop only — and it must outlast every real ending. The engine can
       chain a fresh authority window after an expired deadline (late-settling
       POST promoted to a real verdict), so its true ceiling is deadline 10s +
       transport 8s + fresh authority 10s, not 10s. Firing at 11s called a
       SLOW SUCCESS "Try again" — the double-buy invitation. Every real ending
       (added, failed, uncertain) settles the card early through its event;
       this runs only when the engine has genuinely gone silent. */
    setTimeout(function () { finish('failed'); }, 29000);
  });

  /* ================= INTENT CHIPS (client-side show/hide) ================= */
  var WHISPERS = {
    all: tr('whispers.all', "Everything we make. Choose a feeling to narrow it."),
    meditate: tr('whispers.meditate', "For the sit, the breath, the quiet return."),
    sleep: tr('whispers.sleep', "Frankincense and rose, for the hour before the light goes out."),
    ground: tr('whispers.ground', "Resin and oil that pull you back into your body."),
    wear: tr('whispers.wear', "Worn on the pulse, not sprayed into a room."),
    clear: tr('whispers.clear', "Burn to change how a room feels."),
    skin: tr('whispers.skin', "Rose, frankincense and myrrh, carried in oil for the skin.")
  };
  (function () {
    var chipset = root.querySelector('[data-chipset]'); if (!chipset) return;
    var chips = [].slice.call(chipset.querySelectorAll('.ssb-chip'));
    var seeAll = chips.filter(function (c) { return c.dataset.tag === 'all'; })[0];
    var countEl = root.querySelector('[data-count]');
    var allowed = chips.filter(function (c) { return c !== seeAll; }).map(function (c) { return c.dataset.tag; });
    function tagsFromUrl() {
      var raw = new URL(window.location.href).searchParams.get('feel') || '';
      return raw.split(',').filter(function (tag, index, all) {
        return allowed.indexOf(tag) > -1 && all.indexOf(tag) === index;
      });
    }
    function setTags(tags) {
      chips.forEach(function (chip) {
        chip.classList.toggle('ssb-on', chip !== seeAll && tags.indexOf(chip.dataset.tag) > -1);
      });
    }
    function selectedTags() {
      return chips.filter(function (chip) {
        return chip !== seeAll && chip.classList.contains('ssb-on');
      }).map(function (chip) { return chip.dataset.tag; });
    }
    function writeUrl(tags) {
      var url = new URL(window.location.href);
      if (tags.length) url.searchParams.set('feel', tags.join(','));
      else url.searchParams.delete('feel');
      history.pushState({ ssbFeel: tags }, '', url.pathname + url.search + url.hash);
    }
    function fadeSwap(el, txt) {
      if (!el || el.textContent === txt) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        el.textContent = txt;
        return;
      }
      el.style.opacity = '0';
      setTimeout(function () { el.textContent = txt; el.style.opacity = '1'; }, 150);
    }
    function apply() {
      var active = chips.filter(function (x) { return x !== seeAll && x.classList.contains('ssb-on'); }).map(function (x) { return x.dataset.tag; });
      if (seeAll) seeAll.classList.toggle('ssb-on', active.length === 0);
      root.classList.toggle('ssb-filtering', active.length > 0);
      chips.forEach(function (chip) {
        chip.setAttribute('aria-pressed', chip.classList.contains('ssb-on') ? 'true' : 'false');
      });
      var filtering = active.length > 0;
      root.querySelectorAll('.ssb-card').forEach(function (card) {
        if (card.closest('[data-strip]')) return;
        var tags = (card.dataset.tags || '').split(' ');
        var match = !filtering || active.some(function (t) { return tags.indexOf(t) > -1; });
        card.style.display = match ? '' : 'none';
      });
      // the sets are individually tagged: a burning kit is not an answer to "Nourish skin"
      root.querySelectorAll('.ssb-kit').forEach(function (kit) {
        var kt = (kit.dataset.tags || '').split(' ');
        kit.style.display = (!filtering || active.some(function (t) { return kt.indexOf(t) > -1; })) ? '' : 'none';
      });
      root.querySelectorAll('[data-lane]').forEach(function (lane) {
        var alive = [].slice.call(lane.querySelectorAll('.ssb-kit')).some(function (k) { return k.style.display !== 'none'; });
        lane.style.display = alive ? '' : 'none';
      });

      var shown = 0;
      var perSec = {};
      root.querySelectorAll('[data-sec]').forEach(function (sec) {
        if (!filtering) { sec.style.display = ''; return; }
        var kits = [].slice.call(sec.querySelectorAll('.ssb-kit'));
        if (kits.length) {
          // an editorial band with its own cards answers by them, not by a blanket tag
          var liveKits = kits.filter(function (k) { return k.style.display !== 'none'; });
          sec.style.display = liveKits.length ? '' : 'none';
          perSec[sec.id] = liveKits.length;
          shown += liveKits.length;
          return;
        }
        if (sec.dataset.sec === 'editorial') {
          // the attar band carries no cards, so it answers by its own tags
          var secTags = (sec.dataset.tags || '').split(' ');
          var on = active.some(function (t) { return secTags.indexOf(t) > -1; });
          sec.style.display = on ? '' : 'none';
          perSec[sec.id] = on ? 1 : 0;
          if (on) shown += 1;
          return;
        }
        var live = [].slice.call(sec.querySelectorAll('.ssb-card')).filter(function (c) { return c.style.display !== 'none' && !c.classList.contains('ssb-soldout'); });
        sec.style.display = live.length ? '' : 'none';
        perSec[sec.id] = live.length;
        shown += live.length;
      });

      // the rail must not keep advertising counts the filter has just contradicted
      var resetRail = false;
      root.querySelectorAll('.ssb-rail-pill').forEach(function (pill) {
        var c = pill.querySelector('.ssb-c'); if (!c) return;
        if (c.dataset.full === undefined) c.dataset.full = c.textContent;
        var n = filtering ? (perSec[pill.dataset.anchor] || 0) : c.dataset.full;
        c.textContent = n;
        pill.classList.toggle('ssb-empty', filtering && !n);
        if (filtering && !n) {
          if (pill.classList.contains('ssb-active')) resetRail = true;
          pill.classList.remove('ssb-active');
          pill.setAttribute('aria-disabled', 'true');
          pill.tabIndex = -1;
        } else {
          pill.removeAttribute('aria-disabled');
          pill.removeAttribute('tabindex');
        }
      });
      if (resetRail) {
        var chapterRail = root.querySelector('[data-rail]');
        if (chapterRail) chapterRail.scrollTo({ left: 0, behavior: 'auto' });
      }
      if (countEl) {
        var msg;
        if (!filtering) msg = WHISPERS.all;
        else if (!shown) msg = tr('none', 'Nothing to burn for that feeling yet. Try another.');
        else if (active.length === 1 && WHISPERS[active[0]]) msg = WHISPERS[active[0]];
        else {
          // Liquid renders one string per count the page can produce, so the index
          // is always in range; the English literal is the no-blob degrade path.
          var forms = Array.isArray(I18N.pieces) ? I18N.pieces : null;
          msg = (forms && (forms[shown - 1] || forms[forms.length - 1]))
             || (shown + (shown === 1 ? ' piece' : ' pieces') + ', chosen to sit together.');
        }
        fadeSwap(countEl, msg);
      }
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        if (c === seeAll) { chips.forEach(function (x) { if (x !== seeAll) x.classList.remove('ssb-on'); }); }
        else { c.classList.toggle('ssb-on'); }
        apply();
        writeUrl(selectedTags());
      });
    });
    setTags(tagsFromUrl());
    apply();
    window.addEventListener('popstate', function () {
      setTags(tagsFromUrl());
      apply();
    });
  })();

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  function scrollBehavior() { return REDUCED.matches ? 'auto' : 'smooth'; }

  /* ================= REVEAL / SETTLE ================= */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('ssb-in'); io.unobserve(en.target); } });
  }, { threshold: 0, rootMargin: '0px 0px -60px 0px' });
  /* .ssb-rb-ember is not a reveal -- it wants the class for its own sake. The
     ritual band's ember is an 8s infinite loop that used to start at parse, a
     whole page below the fold (browse.css). Observing it here costs one more
     entry and no new machinery; browse.css pauses it until `.ssb-in` lands. */
  root.querySelectorAll('.ssb-reveal,.ssb-stagger,.ssb-rb-ember').forEach(function (el) { io.observe(el); });
  root.querySelectorAll('.ssb-stagger').forEach(function (s) {
    [].slice.call(s.children).forEach(function (c, i) { c.style.transitionDelay = (i * 60) + 'ms'; });
  });

  /* ===== the sticky layer: the rail rides the real header, whatever its height ===== */
  (function () {
    var header = document.querySelector('.section-header');
    if (!header) return;
    var last = 0;
    function measure() {
      var h = Math.round(header.getBoundingClientRect().height);
      if (h && h !== last) { last = h; root.style.setProperty('--ssb-header-h', h + 'px'); }
    }
    measure();
    window.addEventListener('resize', measure, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(measure).observe(header);
  })();

  /* ===== warming a chapter before the shopper is taken to it =====
     The bands below the resins are content-visibility:auto with estimated
     heights (browse.css), and every card photo is loading="lazy". Both are
     right for a shopper reading downwards and wrong the moment one asks for a
     chapter by name: the scroll lands on an estimate, the real height arrives
     a frame later, and the photos are only discovered once the band has a
     layout box. That is the "I tap Oils and wait" report.

     Unskipping is deliberately permanent for this page view — see the note on
     unskipForHash below; re-engaging the deferral was measured to shift
     content under the reader. Warming the first two photos matches what the
     head-time preload does for a chapter the page LOADED on
     (snippets/browse-landing-preload.liquid): two cards fill the first phone
     screen of a chapter. */
  /* Only as far as the target. To place a chapter exactly the browser needs the
     real height of everything ABOVE it; the bands below can stay deferred and
     keep their win for the rest of the page. Releasing all five at once in an
     interaction frame is the expensive version of this (see .ssb-unskip in
     browse.css). Each band is released once and never re-deferred: re-engaging
     content-visibility:auto swaps real heights back for estimates and was
     measured shifting content ~440px under the reader (2026-07-25). */
  var deferredBands = null;
  function unskipUpTo(sec) {
    if (!deferredBands) {
      deferredBands = [].slice.call(
        root.querySelectorAll('#ssb-sets,#ssb-oils,#ssb-attars,#ssb-tools,.ssb-ritual-band'));
    }
    var stop = sec ? deferredBands.indexOf(sec) : -1;
    var upto;
    if (stop !== -1) {
      upto = stop + 1;
    } else if (sec && sec.compareDocumentPosition) {
      /* Not one of the deferred bands -- the resins, or something inside them.
         Release the ones that sit ABOVE it and no more. DOCUMENT_POSITION_
         PRECEDING is 2. A #resins landing therefore releases nothing at all,
         which is the whole point. */
      upto = 0;
      for (var k = 0; k < deferredBands.length; k++) {
        /* DOCUMENT_POSITION_PRECEDING (2): this band comes before the target. */
        if (sec.compareDocumentPosition(deferredBands[k]) & 2) upto = k + 1;
      }
    } else {
      upto = deferredBands.length;
    }
    for (var i = 0; i < upto; i++) deferredBands[i].classList.add('ssb-unskip');
  }
  /* The menu links #oils; the band is #ssb-oils. Production puts a bare
     <span class="ssb-anchor" id="oils"> BESIDE the section, not inside it, so
     closest('section') would walk past the chapter or find nothing. Resolve
     the alias the same way the markup defines it. */
  function chapterFor(el) {
    if (!el) return null;
    if (el.tagName === 'SECTION') return el;
    var byAlias = el.id && document.getElementById('ssb-' + el.id);
    if (byAlias) return byAlias;
    var next = el.nextElementSibling;
    while (next && next.tagName !== 'SECTION') next = next.nextElementSibling;
    return next || (el.closest ? el.closest('section') : null);
  }
  function warmChapter(sec) {
    unskipUpTo(sec);
    if (!sec || sec.__ssbWarmed) return;
    sec.__ssbWarmed = true;
    var imgs = [].slice.call(sec.querySelectorAll('img[loading="lazy"]'), 0, 2);
    imgs.forEach(function (img) {
      img.loading = 'eager';
      if ('fetchPriority' in img) img.fetchPriority = 'high';
    });
  }

  /* ================= SCROLL-SPY RAIL ================= */
  (function () {
    var rail = root.querySelector('[data-rail]'); if (!rail) return;
    var pills = [].slice.call(rail.querySelectorAll('.ssb-rail-pill'));
    var sections = pills.map(function (p) { return document.getElementById(p.dataset.anchor); }).filter(Boolean);
    var topFrame = 0;
    var railTouchedAt = 0;
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
      rail.addEventListener(ev, function () { railTouchedAt = Date.now(); }, { passive: true });
    });
    function clearAboveChapters() {
      topFrame = 0;
      var visible = sections.filter(function (s) { return s.getClientRects().length; });
      var stale = pills.some(function (p) {
        return p.classList.contains('ssb-active') && p.getAttribute('aria-disabled') === 'true';
      });
      if (stale || !visible.length || visible[0].getBoundingClientRect().top > window.innerHeight * .45) {
        pills.forEach(function (p) { p.classList.remove('ssb-active'); });
        /* Rewinding the rail is right when the page put it where it is, and
           wrong while the shopper's own finger is on it: this runs on every
           scroll frame, so a sideways swipe on the rail plus any vertical
           movement snapped the pills back to the start under the finger. That
           reads exactly like a swipe that did not take. */
        if (rail.scrollLeft && Date.now() - railTouchedAt > 1500) {
          rail.scrollTo({ left: 0, behavior: 'auto' });
        }
      }
    }
    function queueTopCheck() {
      if (!topFrame) topFrame = requestAnimationFrame(clearAboveChapters);
    }
    var spy = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (en.isIntersecting) {
          var id = en.target.id;
          pills.forEach(function (p) {
            var on = p.dataset.anchor === id;
            p.classList.toggle('ssb-active', on);
            // the rail is one scrolling row on a phone: keep the live chapter in view
            if (on && rail.scrollWidth > rail.clientWidth + 4) {
              rail.scrollTo({ left: Math.max(0, p.offsetLeft - (rail.clientWidth - p.offsetWidth) / 2), behavior: scrollBehavior() });
            }
          });
        }
      });
    }, { rootMargin: '-40% 0px -55% 0px' });
    sections.forEach(function (s) { spy.observe(s); });
    window.addEventListener('scroll', queueTopCheck, { passive: true });
    if (window.MutationObserver) {
      var visibilityObserver = new MutationObserver(queueTopCheck);
      sections.forEach(function (s) { visibilityObserver.observe(s, { attributes: true, attributeFilter: ['style'] }); });
    }
    clearAboveChapters();
    pills.forEach(function (p) {
      /* The finger is down and the chapter is known: start its photos and give
         the band its true height now, while the tap is still being made. By
         the time the scroll runs the target is where it will stay. */
      p.addEventListener('pointerdown', function () {
        if (p.getAttribute('aria-disabled') === 'true') return;
        warmChapter(document.getElementById(p.dataset.anchor));
      }, { passive: true });
      p.addEventListener('click', function (e) {
        e.preventDefault();
        if (p.getAttribute('aria-disabled') === 'true') return;
        var t = document.getElementById(p.dataset.anchor);
        if (t) {
          var nextHash = '#' + p.dataset.anchor;
          if (location.hash !== nextHash) {
            var url = new URL(window.location.href);
            url.hash = nextHash;
            /* pushState does NOT fire hashchange, so the hash path below never
               hears about a rail tap. Warm here or the band stays deferred. */
            history.pushState(null, '', url.pathname + url.search + url.hash);
          }
          warmChapter(t);
          t.scrollIntoView({ behavior: scrollBehavior(), block: 'start' });
        }
      });
    });
  })();

  /* ================= VIEW-ALL (chapter head link → the shelf itself) ================= */
  root.querySelectorAll('[data-viewall]').forEach(function (v) {
    v.addEventListener('click', function (e) {
      e.preventDefault();
      var sec = v.closest('section');
      var grid = sec && sec.querySelector('.ssb-grid');
      if (grid) grid.scrollIntoView({ behavior: scrollBehavior(), block: 'start' });
    });
  });

  /* ================= KIT CAROUSEL DOTS ================= */
  root.querySelectorAll('[data-strip]').forEach(function (strip) {
    var lane = strip.closest('.ssb-kit-lane'); if (!lane) return;
    var dotsWrap = lane.querySelector('[data-dots]'); if (!dotsWrap) return;
    var n = strip.children.length; if (n < 2) { dotsWrap.style.display = 'none'; return; }
    /* The dots are server-rendered now (browse-kits.liquid), so the lane holds its
       own height from parse instead of growing 23px when this ran. Only build them
       if the markup did not — a kit resolving on one side and not the other would
       otherwise leave the rail counting the wrong number of pages. */
    if (dotsWrap.children.length !== n) {
      var html = ''; for (var i = 0; i < n; i++) html += '<span class="ssb-d' + (i === 0 ? ' ssb-on' : '') + '"></span>';
      dotsWrap.innerHTML = html;
    }
    var dots = [].slice.call(dotsWrap.children);
    strip.addEventListener('scroll', function () {
      var idx = Math.round(strip.scrollLeft / (strip.scrollWidth - strip.clientWidth) * (n - 1)) || 0;
      dots.forEach(function (d, j) { d.classList.toggle('ssb-on', j === Math.min(idx, n - 1)); });
    }, { passive: true });
  });

  /* ================= THE RITUAL QUIZ ================= */
  (function () {
    var chooser = document.getElementById('ssbChooser'); if (!chooser) return;
    var result = document.getElementById('ssbChooserResult');
    var dots = [].slice.call(chooser.querySelectorAll('.ssb-qd'));
    var backBtn = document.getElementById('ssbQuizBack');
    var stepEl = document.getElementById('ssbRbStep');
    var forkStep = chooser.querySelector('.ssb-cq[data-q="fork"]');
    var answers = {}, flow = [forkStep], pos = 0;

    var CAT = {};
    try { CAT = JSON.parse(document.getElementById('ssb-quiz-catalog').textContent) || {}; } catch (e) { CAT = {}; }

    var RES_HEAD = {
      'first-flame': { h: tr('heads.first-flame.h', 'Begin with the First Flame.'), s: tr('heads.first-flame.s', 'Your first real frankincense, and the flame to light it. One box, and the evening is ready.') },
      'trinity': { h: tr('heads.trinity.h', 'The Trinity, for the whole evening.'), s: tr('heads.trinity.s', 'Three resins and everything to burn them. A different mood for every night.') },
      'alchemist': { h: tr('heads.alchemist.h', 'The Alchemist. The full shelf.'), s: tr('heads.alchemist.s', 'Every resin, every tool. Nothing left to reach for.') },
      'king-queen': { h: tr('heads.king-queen.h', 'King & Queen, worn as one.'), s: tr('heads.king-queen.s', 'Frankincense and rose, the two oils worn together.') },
      'inner-sanctum-attar': { h: tr('heads.inner-sanctum-attar.h', 'Inner Sanctum, on the pulse.'), s: tr('heads.inner-sanctum-attar.s', 'An anointing oil, not a perfume. Frankincense, sandalwood, jasmine and rose, worn a drop at a time.') }
    };
    var GIFT_SUB = tr('giftSub', 'A whole ritual in one box, ready to give.');
    var SINGLE_REASON = {
      'sultans-jade-frankincense': tr('reasons.sultans-jade-frankincense', 'the clean, high resin the sets are built around.'),
      'amber-hojari': tr('reasons.amber-hojari', 'the warmer resin, white and amber tears in one bag.'),
      'dragon-blood': tr('reasons.dragon-blood', 'the crimson resin, for a room that needs clearing.'),
      'hojari-blend': tr('reasons.hojari-blend', 'black to ground, white to lift.')
    };
    function moodResin(m) { return { still: 'sultans-jade-frankincense', warm: 'amber-hojari', clear: 'dragon-blood' }[m]; }

    /* variant pickers over the catalog's honest (>£0) variants. snippets/browse-quiz.liquid
       already drops a variant Shopify reports unbuyable before this JSON ever reaches the
       page (a sold-out sample like rose-otto's OIL-ROSE-0.5 must never win "cheapest" and
       get recommended as a size the PDP won't sell) — this filter is the client-side half
       of that same rule, for any catalog entry that reaches here without going through the
       quiz's own JSON (or an older cached copy of it). `available` missing entirely (older
       cache, or a variant shape that never carried it) reads as buyable rather than dead,
       and if EVERY variant is marked unavailable this falls back to the full list so a
       genuinely sold-out product still resolves to something instead of null. */
    function vAvailable(vs) { var live = vs.filter(function (v) { return v && v.available !== false; }); return live.length ? live : vs; }
    function vMin(c) { var vs = vAvailable((c && c.variants) || []), best = null; vs.forEach(function (v) { if (!best || v.cents < best.cents) best = v; }); return best; }
    function vMax(c) { var vs = vAvailable((c && c.variants) || []), best = null; vs.forEach(function (v) { if (!best || v.cents > best.cents) best = v; }); return best; }
    /* i-th cheapest. Ranking by price is locale-stable; matching a variant by its
       English title is not — Shopify translates variant titles per market. */
    function vRank(c, i) { var vs = vAvailable((c && c.variants) || []).slice().sort(function (a, b) { return a.cents - b.cents; }); return vs[i] || null; }

    function resolveBurn(stage, mood, occasion) {
      var gift = occasion === 'gift', bundle, singleH;
      if (stage === 'first') { if (mood === 'all') { bundle = 'trinity'; singleH = 'hojari-blend'; } else { bundle = 'first-flame'; singleH = moodResin(mood); } }
      else { if (mood === 'all') { bundle = 'alchemist'; singleH = 'sultans-jade-frankincense'; } else { bundle = 'trinity'; singleH = moodResin(mood); } }
      var burnFirst = stage === 'first';
      if (gift) { bundle = { 'first-flame': 'trinity', 'trinity': 'alchemist', 'alchemist': 'alchemist' }[bundle]; if (mood === 'all') singleH = 'amber-hojari'; }
      var reason = SINGLE_REASON[singleH] || '';
      /* The join is done here, not inside the translated string: a leading space in a
         locale value is one editor-save from being trimmed away silently. */
      if (burnFirst) reason = (reason + ' ' + tr('needsCoal', 'You’ll want a coal and a burner to light it.')).trim();
      return { primaryKey: bundle, isSet: true, gift: gift, single: { h: singleH, reason: reason, size: null, variant: vMin(CAT[singleH]) } };
    }
    function resolveWear(character, stage, occasion) {
      var gift = occasion === 'gift', single;
      if (character === 'blend') {
        var bottle = vMax(CAT['inner-sanctum-attar']);
        single = gift
          ? (function (v) { return { h: 'rose-otto', reason: tr('roseGift', 'a smaller rose to give beside it.'), size: v && v.title, variant: v }; })(vMin(CAT['rose-otto']))
          /* The Sample (0.3ml) is hidden everywhere (Sho, 2026-09-12) and excluded
             from #ssb-quiz-catalog (snippets/browse-quiz.liquid), so vMin here
             resolves to the bottle — the only variant left. Copy renamed from
             'sample' to 'sanctumBottle' so nothing recommends "the sample" once
             the SKU is archived in Shopify. */
          : (function (v) { return { h: 'inner-sanctum-attar', reason: tr('sanctumBottle', 'the full bottle, worn on the pulse.'), size: v && v.title, variant: v }; })(vMin(CAT['inner-sanctum-attar']));
        return { primaryKey: 'inner-sanctum-attar', isSet: false, gift: gift, size: bottle ? tr('theBottle', 'The Bottle') + ' · ' + bottle.title : tr('theBottle', 'The Bottle'), variant: bottle, single: single };
      }
      if (character === 'rose') {
        single = stage === 'return'
          ? (function (v) { return { h: 'rose-otto', reason: tr('reasons.rose-otto', 'two thousand roses in a bottle.'), size: v && v.title, variant: v }; })(vMax(CAT['rose-otto']))
          : (function (v) { return { h: 'rose-otto', reason: tr('reasons.rose-otto', 'two thousand roses in a bottle.'), size: v && v.title, variant: v }; })(vMin(CAT['rose-otto']));
      } else { // frank or both → start with the frankincense
        single = stage === 'return'
          ? { h: 'jade-oil', reason: tr('reasons.jade-oil', 'frankincense you can wear.'), size: tr('thePair', 'the pair'), variant: vRank(CAT['jade-oil'], 1) || vMax(CAT['jade-oil']) }
          : (function (v) { return { h: 'jade-oil', reason: tr('reasons.jade-oil', 'frankincense you can wear.'), size: v && v.title, variant: v }; })(vMin(CAT['jade-oil']));
      }
      return { primaryKey: 'king-queen', isSet: true, gift: gift, single: single };
    }

    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

    /* The sentinel is put there by Liquid, not by a translator, so it is always
       present — but a silent no-op replace would drop the number entirely, and a
       missing percentage on a savings badge is worse than an ugly one. */
    function saveLabel(pct) {
      var t = tr('save', 'Save %%PCT%%%');
      return t.indexOf('%%PCT%%') > -1 ? t.split('%%PCT%%').join(String(pct)) : t + ' ' + pct + '%';
    }
    var BAG = '<svg viewBox="0 0 24 24"><path d="M6 8h12l-1 12H7L6 8zM9 8V6a3 3 0 0 1 6 0v2"/></svg>';

    /* ============ THE QUIZ'S OWN BUY CONTROLS ============
       Every other Add on this page is a real <form class="ssb-buy-form">, so it
       inherits the whole pipeline above: the boot sweep, applyDead(), syncAdd()'s
       retirement, revalidate()'s restock check. The quiz result is built here in JS
       from #ssb-quiz-catalog and carries none of that structure -- no form, no
       [data-buy-id] -- so applyDead() has never been able to see it. It armed
       whatever id the payload named, and after the shop refused that id it stayed
       lit, so the next tap posted the same dead variant again. Repeat taps on one
       refused variant are the whole signal this change came from.

       Two gates, matching the rest of the page. Before the tap: an entry the payload
       itself marks unbuyable -- or one this visit already watched the shop refuse --
       is never armed. After the tap: the drawer's verdict retires the control. The
       re-read is the drawer's own, healStalePageAdd, which fetches the product before
       it decides sold_out vs cap -- so a genuine last-unit race still ends as a race,
       and a cap still says "all in cart" and is never written down. */
    function leadDead(id, entry) {
      if (!id) return true;
      if (entry && entry.available === false) return true;
      return readDead().indexOf(String(id)) >= 0;
    }
    /* One control, two endings, one word each -- from the same locale keys the grid
       cards use, so a Polish shopper never reads "Sold out". */
    function retireWord(verdict) {
      return verdict === 'cap' ? tr('addMaxed', 'All in cart') : tr('soldOut', 'Sold out');
    }
    function quizAdd(id, price, off, cls) {
      var body = off
        ? esc(retireWord('sold_out'))
        : esc(tr('add', 'Add')) + ' · <b>' + esc(price) + '</b>';
      return '<button type="button" class="' + cls + '"'
        + (off ? ' disabled aria-disabled="true"' : ' data-quiz-add="' + esc(id) + '"')
        + '>' + BAG + '<span class="ssb-add-lead">' + body + '</span></button>';
    }
    /* Turns a live quiz control off in place. data-quiz-add goes with it: the click
       handler reads that attribute, so its absence is what makes a second tap cost
       nothing, whatever else the DOM is doing. */
    function retireQuizAdd(btn, verdict) {
      var slot = btn.querySelector('.ssb-add-lead') || btn.querySelector('.ssb-cc-price');
      if (slot) slot.textContent = retireWord(verdict);
      var dot = btn.querySelector('.ssb-cc-add');
      if (dot && dot.parentNode) dot.parentNode.removeChild(dot);
      btn.removeAttribute('data-quiz-add');
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      delete btn.dataset.busy;
    }
    /* The same verdict contract the form path listens on (see finish() above), on the
       same event, matched on the same variant so another card's ending never settles
       this one. Only a sellout is written down; a cap is this document's business. */
    function watchQuizAdd(btn, wantId) {
      var settled = false;
      function done(verdict) {
        if (settled) return;
        settled = true;
        document.removeEventListener('sacrasoul:behavior', onBehavior);
        clearTimeout(timer);
        if (verdict === 'sold_out') { rememberDead(wantId); applyDead(); }
        if (verdict === 'sold_out' || verdict === 'cap') retireQuizAdd(btn, verdict);
        else delete btn.dataset.busy;
      }
      function onBehavior(ev) {
        var d = ev && ev.detail;
        if (!d || ['cart_item_added', 'cart_add_failed', 'cart_add_unavailable', 'cart_add_uncertain'].indexOf(d.name) < 0) return;
        var got = d.properties && Number(d.properties.variant_id);
        if (wantId && got && got !== wantId) return;
        done(d.name === 'cart_add_unavailable'
          ? (d.properties && d.properties.reason === 'cap' ? 'cap' : 'sold_out')
          : 'other');
      }
      document.addEventListener('sacrasoul:behavior', onBehavior);
      /* Backstop only, and it must outlast every real ending for the same reason the
         form path's does: the engine can chain a fresh authority window after an
         expired deadline. Releasing early would re-arm the button under a slow add. */
      var timer = setTimeout(function () { done('other'); }, 29000);
    }

    function renderResult(d) {
      var head = RES_HEAD[d.primaryKey] || { h: tr('fallbackHead', 'Here’s where to begin.'), s: '' };
      var sub = d.gift ? GIFT_SUB : head.s;
      var p = CAT[d.primaryKey] || {};
      var card;
      if (d.isSet) {
        // the payoff card carries the full itemized contents + the composed value CTA, like the demo
        var value = p.compare
          ? '<div class="ssb-add-value"><span class="ssb-av-full"><span class="ssb-av-strike">' + esc(p.compare) + '</span> ' + esc(tr('fullValue', 'full value')) + '</span></div>'
          : '';
        var addBtn = (p.variantId || p.available === false)
          ? '<div class="ssb-add-wrap' + (p.compare ? '' : ' ssb-plain') + '" data-addwrap>' + value + quizAdd(p.variantId, p.price, leadDead(p.variantId, p), 'ssb-add') + '</div>'
          : '';
        card = '<div class="ssb-qr-card"><span class="ssb-qr-kick">' + esc(tr('kick', 'Your ritual')) + '</span>'
          + '<div class="ssb-qr-name">' + esc(p.name) + '</div>'
          + '<div class="ssb-qr-tagline">' + esc(p.tagline) + '</div>'
          + (p.contents || '')
          + addBtn
          + '<a class="ssb-cr-further" href="' + esc(p.url) + '">' + esc(tr('inside', 'See what’s inside →')) + '</a></div>';
      } else {
        // the attar leads with THE BOTTLE — the real thing, never the sample price
        var vid = d.variant ? d.variant.id : p.variantId;
        var vprice = d.variant ? d.variant.price : p.price;
        /* d.variant came from vMin/vMax over the catalog's variants array, which
           Liquid has already cut to the buyable ones -- but a dead memory from earlier
           in this visit is newer than any payload, cached or not, so it is checked
           here too. The fallback to p.variantId is the case that needs gating hardest:
           it is reached only when that array came back empty. */
        var attarOff = leadDead(vid, d.variant ? null : p);
        /* An entry that is simply absent from the catalog renders nothing, as before.
           Only an entry that IS here and has no buyable lead earns the retired
           control -- a sold-out word over a product the payload never carried would
           be inventory news the page has no basis for. */
        var attarAdd = (vid || p.variantId || p.available === false)
          ? '<div class="ssb-add-wrap ssb-plain" data-addwrap>' + quizAdd(vid, vprice, attarOff, 'ssb-add') + '</div>'
          : '';
        card = '<div class="ssb-qr-card"><span class="ssb-qr-kick">' + esc(tr('kick', 'Your ritual')) + '</span>'
          + '<div class="ssb-qr-name">' + esc(p.name) + '</div>'
          + '<div class="ssb-qr-tagline">' + esc(tr('anointing', 'An anointing oil, not a perfume.')) + ' ' + esc(d.size || tr('theBottle', 'The Bottle')) + '.</div>'
          + '<p class="ssb-qr-desc">' + esc(p.tagline) + '</p>'
          + attarAdd
          + '<a class="ssb-cr-further" href="' + esc(p.url) + '">' + esc(tr('see', 'See it →')) + '</a></div>';
      }
      var c = CAT[d.single.h] || {};
      var cv = d.single.variant || { id: c.variantId, price: c.price };
      var cname = esc(c.name) + (d.single.nameSuffix ? esc(d.single.nameSuffix) : '') + (d.single.size ? ' · ' + esc(d.single.size) : '');
      /* "Or begin smaller" is the third control, and it takes the same two gates. Its
         price slot carries the retirement word, because that is where the eye already
         is for the number the tap would have honoured. */
      var compOff = leadDead(cv.id, d.single.variant ? null : c);
      var companion = '<button type="button" class="ssb-cr-comp"'
        + (compOff ? ' disabled aria-disabled="true"' : ' data-quiz-add="' + esc(cv.id || '') + '"') + '>'
        + '<img src="' + esc(c.img) + '" alt="' + esc(c.name) + '">'
        + '<span class="ssb-cc-body"><span class="ssb-cc-name">' + cname + '</span><span class="ssb-cc-reason">' + esc(d.single.reason) + '</span></span>'
        + '<span class="ssb-cc-price">' + esc(compOff ? retireWord('sold_out') : (cv.price || '')) + '</span>'
        + (compOff ? '' : '<span class="ssb-cc-add" aria-hidden="true">+</span>') + '</button>';
      return '<div class="ssb-cr-head"><h3 class="ssb-cr-h" tabindex="-1">' + esc(head.h) + '</h3><p class="ssb-cr-frame">' + esc(sub) + '</p></div>'
        + card
        + '<div class="ssb-qr-smaller"><span class="ssb-qr-smaller-label">' + esc(tr('smaller', 'Or begin smaller.')) + '</span><div class="ssb-cr-comp-row">' + companion + '</div></div>'
        /* The "send my ritual to my inbox" form stood here, and it was the notify
           button's mistake in a second costume: it validated the address, painted
           "Sent. Look for your ritual in your inbox." and transmitted nothing —
           there is no capture backend, and the quiz answer was never captured, so
           no flow could have sent the ritual. Worse than a broken promise: the
           Klaviyo snippet's capture-phase document submit listener was quietly
           identifying the address off a form that carried no consent line. The
           form is gone rather than wired up; a real opt-in needs PL/EEA consent
           copy and a backend, which is a decision, not a bug fix. */
        + '<button type="button" class="ssb-cr-restart" data-restart><span aria-hidden="true">↻</span> ' + esc(tr('restart', 'Find it again')) + '</button>';
    }
    function resolve() {
      var d = answers.fork === 'burn' ? resolveBurn(answers.stage, answers.mood, answers.occasion) : resolveWear(answers.character, answers.stage, answers.occasion);
      result.innerHTML = renderResult(d);
      result.classList.add('ssb-show'); chooser.classList.add('ssb-resolved');
      var hh = result.querySelector('.ssb-cr-h'); if (hh) hh.focus({ preventScroll: true });
    }
    var stage = chooser.querySelector('.ssb-quiz-stage');
    function goto(p) {
      // the four-answer question is ~150px taller than the two-answer one; without this
      // the plate snaps. Measure, lock, animate to the new height on the house curve.
      var h0 = stage ? stage.offsetHeight : 0;
      pos = Math.max(0, Math.min(p, flow.length - 1));
      // clear every panel, not just flow members — after a restart or a fork
      // change, a stale panel from the other branch would otherwise stay visible
      chooser.querySelectorAll('.ssb-cq').forEach(function (s) { s.classList.remove('ssb-active'); });
      flow.forEach(function (s, k) { s.classList.toggle('ssb-active', k === pos); });
      dots.forEach(function (d, k) { d.classList.toggle('ssb-on', k === pos); d.classList.toggle('ssb-done', k < pos); });
      if (stepEl) {
        var n = Math.min(pos + 1, 4);
        stepEl.textContent = (Array.isArray(I18N.step) && I18N.step[n - 1]) || ('Question ' + n + ' of 4');
      }
      backBtn.style.display = pos > 0 ? 'inline-flex' : 'none';
      if (stage && h0) {
        var h1 = stage.offsetHeight;
        if (h1 && h0 !== h1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          stage.style.height = h0 + 'px';
          void stage.offsetHeight;
          stage.style.transition = 'height .45s cubic-bezier(.16,1,.3,1)';
          stage.style.height = h1 + 'px';
          clearTimeout(goto._t);
          goto._t = setTimeout(function () { stage.style.transition = ''; stage.style.height = ''; }, 500);
        }
      }
    }
    function buildFlow(fork) {
      var branch = [].slice.call(chooser.querySelectorAll('.ssb-cq[data-branch="' + fork + '"]'));
      flow = [forkStep].concat(branch);
    }
    function back() {
      if (pos <= 0) return;
      result.classList.remove('ssb-show'); chooser.classList.remove('ssb-resolved');
      if (pos === 1) {
        flow.slice(1).forEach(function (s) { s.querySelectorAll('.ssb-cq-opt').forEach(function (o) { o.classList.remove('ssb-sel'); o.setAttribute('aria-pressed', 'false'); }); });
        ['stage', 'mood', 'character', 'occasion'].forEach(function (k) { delete answers[k]; });
        flow = [forkStep]; goto(0);
      } else goto(pos - 1);
    }
    function restart() {
      chooser.classList.remove('ssb-resolved'); result.classList.remove('ssb-show');
      chooser.querySelectorAll('.ssb-cq-opt').forEach(function (o) { o.classList.remove('ssb-sel'); o.setAttribute('aria-pressed', 'false'); });
      answers = {}; flow = [forkStep];
      dots.forEach(function (d) { d.classList.remove('ssb-done'); });
      goto(0);
    }
    chooser.querySelectorAll('.ssb-cq-opt').forEach(function (opt) {
      opt.addEventListener('click', function () {
        var panel = opt.closest('.ssb-cq'), q = panel.dataset.q;
        panel.querySelectorAll('.ssb-cq-opt').forEach(function (o) { o.classList.remove('ssb-sel'); o.setAttribute('aria-pressed', 'false'); });
        opt.classList.add('ssb-sel'); opt.setAttribute('aria-pressed', 'true');
        answers[q] = opt.dataset.val;
        setTimeout(function () {
          if (q === 'fork') { buildFlow(opt.dataset.val); goto(1); }
          else {
            var idx = flow.indexOf(panel);
            if (idx > -1 && idx < flow.length - 1) goto(idx + 1);
            else { dots.forEach(function (d) { d.classList.add('ssb-done'); }); resolve(); }
          }
        }, 200);
      });
    });
    backBtn.addEventListener('click', back);
    result.addEventListener('click', function (e) {
      if (e.target.closest('[data-restart]')) { restart(); return; }
      var add = e.target.closest('[data-quiz-add]');
      if (add) {
        var vid = add.getAttribute('data-quiz-add');
        if (vid && window.SacrasoulCart && window.SacrasoulCart.addAndOpen) {
          /* Refused here, before the request. The verdict is already in hand from an
             earlier tap on this variant, so the repeat costs no 422 and no
             ss_add_to_cart_failed. */
          if (readDead().indexOf(String(vid)) >= 0) { retireQuizAdd(add, 'sold_out'); return; }
          if (add.dataset.busy) return;
          add.dataset.busy = '1';
          watchQuizAdd(add, Number(vid));
          window.SacrasoulCart.addAndOpen(vid, 1, undefined, undefined, undefined, { quiet: true, origin: add });
          var dot = add.querySelector('.ssb-cc-add'); if (dot) { var o = dot.textContent; dot.textContent = '✓'; setTimeout(function () { dot.textContent = o; }, 1050); }
        }
      }
    });
    goto(0);
  })();


  /* Fragment landings: force the deferred bands to real layout before the
     browser aligns the target, so #attars/#tools etc. land exactly. */
  (function () {
    var root = document.documentElement;
    function unskipForHash(initial) {
      var h = location.hash;
      if (!h || h.length < 2) return;
      var el = document.getElementById(h.slice(1));
      if (!el) return;
      /* Releasing a band is deliberately permanent for this page view.
         Re-engaging content-visibility:auto swaps real heights back for
         intrinsic-size estimates, which was measured shifting content ~440px
         under the reader mid-scroll (2026-07-25). */
      warmChapter(chapterFor(el));
      /* At FIRST call the browser has already done the anchor scroll itself,
         against bands the inline gate released at parse time for exactly this
         target, so it landed correctly and a second scroll would be a visible
         nudge for nothing.

         On a LATER hash change it has not. The gate releases only the bands
         above the chapter the page LOADED on -- a #resins landing releases none
         -- so a footer or mega-menu link to a chapter further down scrolls
         against estimated heights, and warmChapter above then gives those bands
         their real heights and moves the target out from under the scroll.
         Measured against the live estimates: about 380px out for #attars, 650px
         for #oils. So the correction is not optional here; it is the whole
         reason this listener exists. */
      if (initial) return;
      requestAnimationFrame(function () {
        var el2 = document.getElementById(h.slice(1));
        if (el2) el2.scrollIntoView();
      });
    }
    unskipForHash(true);
    window.addEventListener('hashchange', function () { unskipForHash(false); });
  })();

})();
